//TODO: THIS SHOULD BE REFACTORED
export const QUERY_KEYS = {
  studentMergePotentialDuplicates: ["studentMergePotentialDuplicates"],
  accountStudentReport: ["accountStudentReport"],
  v1SessionsUnpostedCountGet: ["v1SessionsUnpostedCountGet"],
  v1SessionsSlimGet: ["v1SessionsSlimGet"],
  v1UsersIdGet: ["v1UsersIdGet"],
};
